import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BsTelephone } from "react-icons/bs";
import { CiMail } from "react-icons/ci";
import { formService } from '../../../services/formServices';

const ContactModal = ({ onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        interest: '',
        message: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const nameRegex = /^[a-zA-Z ]{2,30}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let error = false;

        if (!nameRegex.test(formData.name)) {
            alert("Name must be between 2 and 30 characters and only contain letters and spaces");
            error = true;
        } else if (!emailRegex.test(formData.email)) {
            alert("Invalid email address");
            error = true;
        } else if (!formData.interest) {
            alert("Please select your interest");
            error = true;
        } else if (!formData.message.trim()) {
            alert("Please enter your message");
            error = true;
        }

        if (error) {
            setIsSubmitting(false);
            return;
        }

        try {
            const submissionData = {
                name: formData.name,
                email: formData.email,
                interest: formData.interest,
                message: formData.message,
                sourcePage: window.location.pathname
            };

            await formService.submitContactForm(submissionData);
            alert("Thank you for contacting us! We'll get back to you soon.");

            setFormData({
                name: '',
                email: '',
                interest: '',
                message: '',
            });
            onClose();
        } catch (error) {
            console.error('Contact form submission error:', error);
            alert(error.response?.data?.message || "Failed to submit form. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-modal">
            <div className="modal-grid">
                {/* Left Column */}
                <div className="modal-left order-mobile-2">
                    <motion.div
                        className="modal-header"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1 }}
                    >
                        <span className="modal-label">GET IN TOUCH</span>
                        <h2 className="modal-title">Schedule your Appointment</h2>
                        <p className="modal-subtitle">
                            Reach out to us if you have common problems and questions.
                        </p>
                    </motion.div>

                    {/* Contact Info */}
                    <motion.div
                        className="contact-info-wrapper"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                    >
                        <div className="contact-card glass-card">
                            <div className="card-header">
                                <div className="country-info">
                                    <span className="country-flag">🇮🇳</span>
                                    <span className="country-name">India</span>
                                </div>
                            </div>

                            <div className="contact-details">
                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <BsTelephone size={18} />
                                    </div>
                                    <span className="contact-text">+91-7880122103</span>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <CiMail size={20} />
                                    </div>
                                    <span className="contact-text">business@logiqlink.com</span>
                                </div>
                            </div>

                            <div className="contact-note">
                                <p>Available Monday to Friday, 9AM - 6PM</p>
                            </div>
                        </div>
                    </motion.div>
                </div>

                {/* Right Column - Form */}
                <motion.div
                    className="modal-right order-mobile-1"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.2 }}
                >
                    <div className="form-wrapper glass-card">
                        <h3 className="form-title">Send us a Message</h3>
                        <form onSubmit={handleSubmit} className="contact-form">
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Full Name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                    className="form-input"
                                    disabled={isSubmitting}
                                />
                            </div>

                            <div className="form-group">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email Address"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                    className="form-input"
                                    disabled={isSubmitting}
                                />
                            </div>

                            <div className="form-group">
                                <select
                                    name="interest"
                                    value={formData.interest}
                                    onChange={handleInputChange}
                                    required
                                    className="form-select"
                                    disabled={isSubmitting}
                                >
                                    <option value="">Select Interest</option>
                                    <option value="consultation">Consultation</option>
                                    <option value="support">Technical Support</option>
                                    <option value="partnership">Partnership</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <textarea
                                    name="message"
                                    placeholder="Your Message"
                                    rows="4"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    required
                                    className="form-textarea"
                                    disabled={isSubmitting}
                                />
                            </div>

                            <motion.button
                                type="submit"
                                className="submit-btn"
                                disabled={isSubmitting}
                                whileHover={!isSubmitting ? { scale: 1.02 } : {}}
                                whileTap={!isSubmitting ? { scale: 0.98 } : {}}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner"></span>
                                        Submitting...
                                    </>
                                ) : 'Submit'}
                            </motion.button>
                        </form>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default ContactModal;